import { z } from 'zod';
/**
 * Envelope único de erro da API. O error handler do Fastify sempre responde
 * neste formato, e web e admin sabem interpretá-lo sem adivinhação.
 */
export const apiErrorSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
        details: z.unknown().optional(),
    }),
});
//# sourceMappingURL=error.js.map